import { createContext, useContext } from 'react'

export const SurveyParamsContext = createContext({ userId: null })

export const useSurveyParams = () => useContext(SurveyParamsContext)
